export default __webpack_public_path__ + "static/media/로보엠디_개인정보처리방침_0511.b988f03d.pdf";